import React from 'react';

import NoData from 'components/common/NoData/noData';
import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';

import classes from 'components/widgets/PrioritiesMatrix/components/Cards/Cards.module.scss';
import { CardList } from 'components/widgets/PrioritiesMatrix/components/Cards/components/CardList/CardList';
import { CardsHeader } from 'components/widgets/PrioritiesMatrix/components/Cards/components/CardsHeader/CardsHeader';

export const Cards = ({
    selected,
    linkToBattlecards,
    buttons,
    selectedTypeWithRole,
    isOverdueFilter,
    handleOverdueFilter,
    isDelayDriverFilter,
    handleDelayDriverFilter,
    isCriticalPathFilter,
    handleCriticalPathFilter,
    isAssignedToMeFilter,
    handleAssignedToMeFilter,
    isCardsLoading,
    filteredCardsData,
    cards,
}) => {
    return (
        <div data-testid={'cards'} className={`${classes.cards} ${classes[selected.type]}`}>
            <CardsHeader
                selected={selected}
                linkToBattlecards={linkToBattlecards}
                selectedTypeWithRole={selectedTypeWithRole}
                buttons={buttons}
                isOverdueFilter={isOverdueFilter}
                handleOverdueFilter={handleOverdueFilter}
                isDelayDriverFilter={isDelayDriverFilter}
                handleDelayDriverFilter={handleDelayDriverFilter}
                isCriticalPathFilter={isCriticalPathFilter}
                handleCriticalPathFilter={handleCriticalPathFilter}
                isAssignedToMeFilter={isAssignedToMeFilter}
                handleAssignedToMeFilter={handleAssignedToMeFilter}
            />
            <div className={`${classes.cardsContainer} ${isCardsLoading && classes.isLoading}`}>
                <OverlayWithSpinner isLoading={isCardsLoading} />
                {filteredCardsData?.length === 0 && <NoData className={classes.noData} />}
                {!isCardsLoading && filteredCardsData && cards && cards.length > 0 && (
                    <CardList filteredCardsData={filteredCardsData} />
                )}
            </div>
        </div>
    );
};
